module.exports = __webpack_public_path__ + "img/banner01.702d1ac2.png";